import React from "react";
import "./SnaitheFuture.css";
import Robot1GirlImage from "../../../assets/Robot1-girl.jpg";

const SnaitheFuture = () => {
  return (
    <div className="box-Robot-man-custom">
      <div className="text-container-Robot-man-custom">
        <div className="title-Robot-man-custom">Snáithe's Future</div>

        <div className="text-Robot-man-custom">
          At Snáithe, we envision a future of boundless possibilities and
          transformative growth. Rooted in Sweden, our company is poised to be a
          beacon of innovation, driving excellence across a spectrum of sectors.
          As we embark on this remarkable journey, we hold a steadfast
          commitment to the people who place their trust in us.
          <br />
          <br />
          Empowering Diverse Industries: Snáithe is not confined by industry
          limitations; rather, we embrace the challenge of diverse sectors. From
          the corridors of business to the echelons of government, from the
          realm of education to the cutting-edge IT and AI domains, from the
          intricate nuances of the vehicle and wood industries to the complex
          domains of tire manufacturing and mining, and even venturing into the
          dynamic realm of cryptocurrency - Snáithe stands as a catalyst for
          transformation. Our multi-faceted approach enables us to tailor
          solutions that transcend boundaries and foster growth.
        </div>
      </div>
      <div className="image-container-right-1-Robot-man-custom">
        <img src={Robot1GirlImage} alt="Square Image" />
      </div>
    </div>
  );
};

export default SnaitheFuture;
